/**
 * Map of strings that map to identifiers for worklife services offered to customers (where the identifiers
 * are derived from the customer properties stored in the backend).
 */
export const WORKLIFE_SERVICE_IDS = {
  LEGAL_SERVICES: {
    id: 'legal',
    dataTestId: 'workLife-selectLegalServices',
  },
  FINANCIAL_SERVICES: {
    id: 'financial',
    dataTestId: 'workLife-selectFinancialServices',
  },
  IDENTITY_THEFT: {
    id: 'identity',
    dataTestId: 'workLife-selectIdentityTheft',
  },
  DEPENDENT_CARE: {
    id: 'dependent',
    dataTestId: 'workLife-selectDependentCare',
  },
}

export enum IllustrationTypes {
  FINANCIAL = 'Financial',
  LEGAL = 'Legal',
  SECURITY = 'Security',
  DEPENDENTS = 'Dependents',
}

export const CARELON_BASE_URL = 'https://worklife.carelonwellbeing.com'
export const SURVEYMONKEY_CUSTOMER_NAMES = ['momentive', 'surveymonkey']
